<template>
  <SkeletonAnimation>
    <div class="coupon-skeleton-component">
       <div class="back">
          <PartItem
          :styles="{
            width: '146px',
            height: '22px',
            'border-radius': '4px ',
          }"
        ></PartItem>
        </div>
      <div class="example">
        <div class="left">
          <div class="example-title"></div>
          <div class="example-desc">
            <div class="example-desc_text"></div>
            <!-- <i class="el-icon-question"></i> -->
          </div>
        </div>
        <div class="right">
          <!-- <i class="el-icon-plus"></i> -->
        </div>
      </div>
      <div v-for="item in 24" :key="item" class="coupon-lists">
        <div class="list-left">
          <div class="round"></div>
          <div class="list-left-flex">
            <div>
              <PartItem :style="block1" />
            </div>
            <div>
              <PartItem :style="block2" />
              <PartItem :style="block3" />
            </div>
          </div>
          <PartItem :style="block4" />
        </div>
        <div class="list-right">
          <div class="round"></div>
        </div>
      </div>
    </div>
  </SkeletonAnimation>
</template>
<script>
import SkeletonAnimation from '../../SkeletonAnimation';
import PartItem from '../partItem.vue';

export default {
  name: 'OrderSkeleton',
  components: {
    SkeletonAnimation,
    PartItem,
  },
  data() {
    return {
      block1: {
        width: '36px',
        height: '36px',
        background: '#E5E5EB',
        'border-radius': '4px',
        'margin-right': '10px',
      },
      block2: {
        width: '145px',
        height: '16px',
        background: '#E5E5EB',
        'border-radius': '4px',
        'margin-bottom': '6px',
      },
      block3: {
        width: '100px',
        height: '14px',
        background: '#E5E5EB',
        'border-radius': '4px',
      },
      block4: {
        width: '145px',
        height: '12px',
        background: '#E5E5EB',
        'border-radius': '4px',
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.coupon-skeleton-component {
  .back{
    height: 60px;
    display: flex;
    align-items: center;
    width: 1156px;
    margin: 0 auto;
  }
  width: 1156px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .example {
    width: 372px;
    height: 128px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    padding: 16px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .example-title {
    height: 16px;
    width: 126px;
    border-radius: 4px;
    margin-bottom: 14px;
    background: #e5e5eb;
  }
  .example-desc {
    display: flex;
    align-items: center;
  }
  .example-desc_text {
    height: 12px;
    width: 70px;
    border-radius: 4px;
    background: #e5e5eb;
  }
  .coupon-lists {
    margin-bottom: 20px;
    width: 372px;
    height: 128px;
    border-radius: 8px;
    display: flex;
    overflow: hidden;
  }
  .list-left {
    width: 225px;
    background: #fff;
    position: relative;
    padding: 20px 0 0 16px;
    .round {
      width: 15px;
      height: 15px;
      background: #f5f5f5;
      border-radius: 50%;
      position: absolute;
      left: -5px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .list-right {
    flex: 1;
    background: #fffbf9;
    position: relative;
    .round {
      width: 15px;
      height: 15px;
      background: #f5f5f5;
      border-radius: 50%;
      position: absolute;
      right: -5px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.list-left-flex {
  display: flex;
  margin-bottom: 6px;
}
.el-icon-question {
  margin-left: 4px;
}
</style>
